import Nav from '@/pages/home/components/Nav';
import Hero from '@/pages/home/components/Hero';
import BoxOffice from '@/pages/home/components/BoxOffice';
import Schedule from '@/pages/home/components/Schedule';
import Release from '@/pages/home/components/Release';
import WindowSection from '@/pages/home/components/WindowSection';
import News from '@/pages/home/components/News';
import Faq from '@/pages/home/components/Faq';
import About from '@/pages/home/components/About';
import Footer from '@/pages/home/components/Footer';
import BackTop from '@/pages/home/components/BackTop';
import { faqList } from '@/mocks/cinema';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqList.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Nav />
        <main>
          <Hero />
          <BoxOffice />
          <Schedule />
          <Release />
          <WindowSection />
          <News />
          <Faq />
          <About />
        </main>
        <Footer />
        <BackTop />
      </div>
    </>
  );
}